import { render, staticRenderFns } from "./main-commitments.vue?vue&type=template&id=7be8f852&scoped=true"
import script from "./main-commitments.vue?vue&type=script&lang=js"
export * from "./main-commitments.vue?vue&type=script&lang=js"
import style0 from "./main-commitments.vue?vue&type=style&index=0&id=7be8f852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be8f852",
  null
  
)

export default component.exports